import { h } from "preact";

import Avatar from "./Avatar.jsx";

export default function TalentHeader({ children, previewMode, userData }) {
  return (
    <div class="talent-header">
      <div class="talent-header__content">
        <div class="row">
          <div class="col s12 m10 push-m1 talent-header__inner-content">
            <Avatar
              grey={previewMode}
              noHover
              user={previewMode ? null : userData}
              plain
              extraBig
              class="talent-header__avatar"
            />
            <div class="talent-header__actions">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
